module.exports = __webpack_public_path__ + "static/media/success_filled_green.b873b429.svg";